export const zwaveSensorTypes = [
  'sensor_notification',
  'sensor_binary',
  'sensor_multilevel',
]
